<template>
    <div class="xc-page">
        <div class="xc-page-main">
            <!-- 面包屑 -->
            <div class="xc-breadcrumb">
                <a href="">故障管理</a>
            </div>

            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <!-- UI出图上有这么个标题，为了和其他模块保持统一暂时没有加上 -->
                        <!-- <h3 class="page-title">故障管理</h3> -->

                        <!-- 搜索查询 -->
                        <div class="xc-form-inline">
                            <div class="xc-form-inline ele-float">
                                <xc-form-item label="上报时间：">
                                    <input type="text" placeholder="请输入" v-model="mix_query.addTime" class="xc-input" id="add-time">
                                </xc-form-item>
                                <xc-form-item label="状态：">
                                    <select class="xc-select" v-model="mix_query.authStatus">
                                        <option value selected>全部</option>
                                        <option>已处理</option>
                                        <option>未处理</option>
                                    </select>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button class="xc-btn xc-btn-primary" @click="search(mix_query)">查询</button>
                                </div>
                            </div>
                        </div>

                        <!-- 故障列表 -->
                        <table class="xc-table fault-table">
                            <thead>
                                <tr>
                                    <td>编号</td>
                                    <td style="width:80px;">城市</td>
                                    <td style="width:120px;">门店名称</td>
                                    <td style="width:95px;">终端名</td>
                                    <td>设备型号</td>
                                    <td style="width:80px;">故障图片</td>
                                    <td style="width:600px;">故障类型</td>
                                    <td style="width:80px;">处理状态</td>
                                    <td>上报时间</td>
                                    <td style="width:80px;">操作</td>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="faultList == null || faultList == ''">
                                    <td colspan="10">暂无数据！</td>
                                </template>
                                <template v-else>
                                    <tr v-for="(item, index) in faultList" :key="index">
                                        <td>
                                            {{item.id}}
                                        </td>
                                        <td>
                                            {{item.city}}
                                        </td>
                                        <td>
                                            {{item.storeName}}
                                        </td>
                                        <td>
                                            {{item.deviceName}}
                                        </td>
                                        <td>
                                            {{item.deviceModel}}
                                        </td>
                                        <td>
                                            <a id="examine" @click="faultImg(item.imageUrl)">查看</a>
                                        </td>
                                        <td>
                                            {{item.breakdownType}}
                                        </td>
                                        <td>
                                            <span v-if="item.authStatus == 1">已处理</span>
                                            <span v-else>未处理</span>
                                        </td>
                                        <td>
                                            {{item.addTime}}
                                        </td>
                                        <td>
                                            <a id="dispose" @click="faultDispose(item)" v-if="item.authStatus == 0">处理</a>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <!-- 故障处理窗口 -->
                        <div class="xc-modal xc-modal-dialog" id="fault-dispose" v-if="faultDisposeWindow == true">
                            <div class="xc-modal-mask">
                                <div class="xc-modal-wrap">
                                    <div class="xc-modal-content">
                                        <div class="xc-modal-header">
                                            <div class="xc-modal-title">故障处理</div>
                                        </div>
                                        <div class="xc-modal-body xc-info">
                                            <div class="xc-form-inline">
                                                <xc-form-item label="终端名称：">
                                                    <div class="list-data">
                                                        {{windowList.deviceName}}
                                                    </div>
                                                </xc-form-item>
                                                <xc-form-item label="城市：">
                                                    <div class="list-data">
                                                        {{windowList.city}}
                                                    </div>
                                                </xc-form-item>
                                            </div>
                                            <div class="xc-form-inline">
                                                <xc-form-item label="门店名称：">
                                                    <div class="list-data">
                                                        {{windowList.storeName}}
                                                    </div>
                                                </xc-form-item>
                                                <xc-form-item label="设备型号：">
                                                    <div class="list-data">
                                                        {{windowList.deviceModel}}
                                                    </div>
                                                </xc-form-item>
                                            </div>
                                            <div class="xc-form-inline">
                                                <xc-form-item label="故障类型：">
                                                    <div class="list-data">
                                                        {{windowList.breakdownType}}
                                                    </div>
                                                </xc-form-item>
                                                <xc-form-item label="处理状态：">
                                                    <div class="list-data">
                                                        <span v-if="windowList.authStatus == 0">未处理</span>
                                                    </div>
                                                </xc-form-item>
                                            </div>
                                            <div class="xc-form-inline">
                                                <xc-form-item label="故障图片：">
                                                    <div class="list-data">
                                                        <img :src="windowList.imageUrl">
                                                    </div>
                                                </xc-form-item>
                                                <xc-form-item label="处理结果：">
                                                    <div class="list-data">
                                                        <input type="radio" class="xc-radio radio" v-model="radioStatus">
                                                        <span>已处理</span>
                                                    </div>
                                                </xc-form-item>
                                            </div>
                                            <div class="hint-text">
                                                {{hintText}}
                                            </div>
                                        </div>
                                        <div class="xc-modal-footer xc-flex-center">
                                            <div class="xc-btn-group">
                                                <div class="xc-btn xc-btn-default" @click="faultDisposeWindow = false">取消</div>
                                                <div class="xc-btn xc-btn-primary" @click="disposeSave(windowList.id, windowList.authStatus)">保存</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 故障图片窗口 -->
                        <div class="xc-modal xc-modal-dialog" id="fault-img" v-if="faultImgWindow == true">
                            <div class="xc-modal-mask">
                                <div class="xc-modal-wrap">
                                    <div class="xc-modal-content">
                                        <div class="xc-modal-header">
                                            <div class="xc-modal-title">故障照片</div>
                                        </div>
                                        <div class="xc-modal-body dialog-height">
                                            <div class="img-box" v-if="imgList">
                                                <img :src="imgList">
                                            </div>
                                            <div v-else>
                                                <p class="marked-words">播控助手未上传故障照片！</p>
                                            </div>
                                        </div>
                                        <div class="xc-modal-footer xc-flex-center">
                                            <div class="xc-btn-group">
                                                <div class="xc-btn xc-btn-primary" @click="faultImgWindow = false">关闭</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分页 -->
            <div class="xc-page-footer">
                <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
            </div>
        </div>
    </div>
</template>

<script>
import faultApi from '../api/fault-management'
import listMixin from "../xc-ui/mixins/list"
import '@/libs/flatpickr'

export default {
    name: 'faultManagement',
    mixins: [listMixin],
    data() {
        return {
            // 搜索查询
            mix_query: {
                addTime: '',  // 上报时间
                authStatus: ''  // 状态 ---> 未处理：0，已处理：1
            },

            faultList: [],  // 故障列表
            windowList: null,  // 故障处理列表
            imgList: '',  // 图片列表
            faultDisposeWindow: false,  // 故障处理
            faultImgWindow: false,  // 故障图片
            radioStatus: true,  // 单选按钮
            hintText: '',  // 提示语
        }
    },
    created() {
        // flatpickr初始化
        this.$nextTick(function() {
            document.getElementById('add-time').flatpickr({
                enableTime: false,
                
            })
        })

        this.initData()  // 数据初始化调用
    },
    methods: {
        // 数据初始化
        initData() {
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            faultApi.getFaultList(search).then(res => {
                this.faultList = res.data.list;
                this.mix_total = res.data.total;
                this.mix_page = res.data.pageNum;
                this.mix_pageSize = res.data.pageSize;
            })
        },

        // 故障处理窗口
        faultDispose(data) {
            this.faultDisposeWindow = true
            this.windowList = data
        },

        // 故障图片窗口
        faultImg(data) {
            this.faultImgWindow = true
            this.imgList = data
        },

        // 保存
        disposeSave(id, status) {
            // 判断单选框是否勾选
            if(this.radioStatus == true) {
                this.markedWords('请勾选处理结果')
            }else {
                this.faultDisposeWindow = false

                // 故障处理
                if(status == 0) {
                    status = 1
                    faultApi.getFaultHandling(id, status).then(res => {
                        if(res.code == 0) {
                            this.initData()
                        }
                    })
                }
            }
        },

        // 提示语
        markedWords(text) {
            this.hintText = text
        },

        // 搜索查询
        search(parame) {
            switch(parame.authStatus) {
                case '已处理':
                    parame.authStatus = 1
                    break
                case '未处理':
                    parame.authStatus = 0
                    break
                default:
                    parame.authStatus = ''
            }
            faultApi.getFaultList(parame).then(res => {
                this.initData(res.data)
            })
        }
    }
}
</script>

<style scoped lang="scss">
// UI出图上有这么个标题，为了和其他模块保持统一暂时没有加上
// .page-title {
//     margin-bottom: 20px;
// }
#examine {
    color: rgb(74, 128, 247);
    cursor: pointer;
}

#dispose {
    border: 1px solid rgb(74, 128, 247);
    border-radius: 5px;
    font-size: 13px;
    color: rgb(74, 128, 247);
    padding: 2px 15px;
    cursor: pointer;
}

#fault-dispose .list-data {
    width: 160px;
    line-height: 30px;
    padding: 0 10px;
}

.dialog-height {
    max-height: 600px;
}

.dialog-height img {
    display: block;
    max-height: 550px;
    margin: auto;
}

.radio {
    margin-right: 7px;
}

.marked-words {
    color: red;
    margin-top: 15px;
}

.hint-text {
    color: red;
    font-size: 13px;
}

.fault-table {
    margin-bottom: 20px;
}
</style>
